import { isPossiblePhoneNumber, isValidPhoneNumber } from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import { UTILS } from "utils";

const getCountryFromPhoneNumber = (value) => {
  if (!value) return null;

  try {
    const phoneNumber = parsePhoneNumber(value);
    return phoneNumber?.country || null; // e.g. "AE"
  } catch (error) {
    return null;
  }
};

const validatePhoneNumber = (value, t=()=>{}) => {
    if (!value) {
        return Promise.reject(t("Phone is required"));
      }

      const country = getCountryFromPhoneNumber(value);

      if (!country) {
        return Promise.reject(t("Please enter a valid phone number"));
      }

      if (!isPossiblePhoneNumber(value, country)) {
        return Promise.reject(t("Please enter a valid phone number"));
      }

      if (!isValidPhoneNumber(value, country)) {
        return Promise.reject(t("Please enter a valid phone number"));
      }

      return Promise.resolve();
};

const validateEmail = (value, t=()=>{}) => {
    if (!value) {
        return Promise.reject(t("Email is required"));
    }
    if (!UTILS.emailValidation().test(value)) {
        return Promise.reject(t("Please enter a valid email"));
    }
    return Promise.resolve();
};


const validatePassword = (value, t=()=>{}) => {
    if (!value) {
        return Promise.reject(t("Password is required"));
    }
    if (value.length < 8) {
        return Promise.reject(t("Password must be at least 8 characters long"));
    }
    const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  if (!strongPasswordRegex.test(value)) {
    return Promise.reject(
      t(
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      )
    );
  }
    return Promise.resolve();
};


const validatePhoneNumberWithoutPromise = (value, t=()=>{}) => {
  if (!value) {
    return t("Phone is required");
  }
  const country = getCountryFromPhoneNumber(value);

  if (!country || !isPossiblePhoneNumber(value, country) || !isValidPhoneNumber(value, country)) {
    return t("Please enter a valid phone number");
  }
  return null
};

export { getCountryFromPhoneNumber, validatePhoneNumber, validateEmail, validatePassword, validatePhoneNumberWithoutPromise };